import { PillStateType } from '@kubit/web-ui-components/pill/types';
import { KubitPillSizeType, KubitPillVariantType } from '../../variants';
const buildCommonProps = (FOUNDATIONS, FONT) => ({
    rootContainer: {
        display: 'flex',
        flex: '1',
    },
    kubitPill: {
        variant: KubitPillVariantType.SEGMENTED_CONTROL,
        size: KubitPillSizeType.DEFAULT,
    },
});
export const getPillSegmentedControlStyles = (FOUNDATIONS, FONT) => {
    const commonProps = buildCommonProps(FOUNDATIONS, FONT);
    return {
        [PillStateType.DEFAULT]: {
            ...commonProps,
        },
        [PillStateType.SELECTED]: {
            ...commonProps,
        },
        [PillStateType.DISABLED]: {
            ...commonProps,
        },
        [PillStateType.DISABLED_SELECTED]: {
            ...commonProps,
        },
    };
};
//# sourceMappingURL=segmentedControl.js.map